/**
 * El monitoreo se muestra del corte más reciente al más antiguo
 * (29/09/2026, Norman: «que estén al revés y que marque de otro color el
 * último monitoreo»). Si dos cortes caen el mismo día, va primero el que se
 * registró después. Se ordena una copia: el arreglo original conserva el
 * orden del FOS-005, que es el que usan la vista tipo Excel y la carga.
 */
export function ordenReciente<T extends { fechaMonitoreo?: Date | string }>(
  lista: T[] | null | undefined,
  id: (corte: T) => number | undefined,
): T[] {
  return [...(lista || [])].sort(
    (a, b) => tiempo(b.fechaMonitoreo) - tiempo(a.fechaMonitoreo) || (id(b) || 0) - (id(a) || 0),
  );
}

function tiempo(fecha?: Date | string): number {
  const t = fecha ? new Date(fecha).getTime() : Number.NaN;
  return Number.isNaN(t) ? 0 : t;
}
